// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { CYCLE_TIME_SEGMENTS } from '@/fulfillment/components/cycle-time-segments';
import { useFulfillmentCycleTimeReport } from '@/fulfillment/hooks/use-fulfillment-analytics';
import { CycleTimeAnalyticsSection } from '@/report/components/cycle-time-analytics-section';
import type { DateRange } from '@mui/x-date-pickers-pro';
import type { DateTime, IANAZone, Interval } from 'luxon';

const CYCLE_TIME_ACCORDION_EXPANDED_STORAGE_KEY =
  'fulfillment-cycle-time-accordion-expanded';

interface FulfillmentAnalyticsSectionProps {
  interval: Interval;
  timezone: IANAZone;
  isDateRangeInvalid: boolean;
  onDateRangeChange: (dateRange: DateRange<DateTime>) => void;
}

function useFulfillmentCycleTimeReportQuery(filter: { interval: Interval }) {
  return useFulfillmentCycleTimeReport({ filter });
}

export function FulfillmentAnalyticsSection(
  props: FulfillmentAnalyticsSectionProps
) {
  return (
    <CycleTimeAnalyticsSection
      interval={props.interval}
      timezone={props.timezone}
      isDateRangeInvalid={props.isDateRangeInvalid}
      onDateRangeChange={props.onDateRangeChange}
      segments={CYCLE_TIME_SEGMENTS}
      singularNoun="order"
      domIdPrefix="fulfillment-cycle-time"
      expandedStorageKey={CYCLE_TIME_ACCORDION_EXPANDED_STORAGE_KEY}
      errorBoundaryMessage="Failed to load fulfillment cycle time report"
      summarySkeletonWidthPx={260}
      useReportQuery={useFulfillmentCycleTimeReportQuery}
      getTotalCount={(report) => report.totalOrders}
    />
  );
}
